// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"styles_logoLink__3-k-a"};